import React, { Fragment, ReactElement } from 'react';
import styled from 'styled-components';

import { SpacerVertical, Typography, Link, List } from '@klarna/bubble-ui';

export const TextWithNewlines = styled.div`
  white-space: pre-wrap;
`;

type StrongParagraphFn = (value: string) => ReactElement;

const strong: StrongParagraphFn = value => (
  <Typography textToken="text-style/text/super-paragraphs/body/bold">{value}</Typography>
);

export type ParagraphTranslationProps = Record<string, unknown> & {
  text?: string;
  link?: boolean | string;
  list?: { text: string }[];
};

export type ParagraphsProps = {
  tKey: string;
  params: ParagraphTranslationProps;
  tArray: ArrayTranslatorFunction<ParagraphTranslationProps>;
};

export const Paragraphs: React.FC<ParagraphsProps> = ({
  tKey,
  params,
  tArray,
}: ParagraphsProps): ReactElement | null => {
  const translations = tArray(tKey, { ...params, strong });

  if (!translations || !translations.length) {
    return null;
  }

  return (
    <>
      {translations.map(({ text, list, link }) => (
        <Fragment key={text as string}>
          {text &&
            (link ? (
              // @ts-expect-error: FIXME
              <Link href={link} target="_blank" rel="noopener noreferrer">
                {text}
              </Link>
            ) : (
              <Typography textToken="text-style/text/super-paragraphs/body/regular">
                <TextWithNewlines>{text}</TextWithNewlines>
              </Typography>
            ))}
          {list && Array.isArray(list) && (
            <List>
              {list.map((r, i) => (
                <List.Item key={i}>{r.text}</List.Item>
              ))}
            </List>
          )}
          <SpacerVertical spaceToken="space/150" />
        </Fragment>
      ))}
    </>
  );
};
